<template>
  <nav class="navbar navbar-dark sticky-top custom-navbar-color flex-md-nowrap p-0 shadow" id="navbar-top">
    <a class="navbar-brand col-md-3 col-lg-2 mr-0 px-3" href="#">
      <img src="../../public/synagro.png" alt="Logo de Panel de IT" style="max-width: 125px; height: auto;">
    </a>
    <button class="navbar-toggler position-absolute d-md-none collapsed" type="button" data-toggle="collapse" data-target="#sidebarMenu" aria-controls="sidebarMenu" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>
    <div class="w-100"></div>
    <ul class="navbar-nav px-3">
        <li class="nav-item text-nowrap" >
            <a class="nav-link text-white font-weight-bold" href="#"> {{ user }}</a>
        </li>
    </ul>
    <ul class="navbar-nav px-3">
        <li class="nav-item text-nowrap" v-if="isLoggedIn">
            <a class="nav-link text-white font-weight-bold" href="#" @click="logout">Sign out</a>
        </li>
    </ul>
  </nav>
</template>

<style>
.custom-navbar-color {
  background-color: #173667;
}
</style>

<script>
import {TokenService} from '../storage/service.js'

export default {
  name: 'Navbar',
  data: function(){
    return {
      user: TokenService.getUser(),
    }
  },
  props: {
    msg: String
  },
  computed : {
      isLoggedIn : function(){ return this.$store.getters.isLoggedIn},
  },
  watch: {
    searching(val){
      // console.log(val)
      this.globalsearching = val
      // console.log(this.globalsearching)
    }
  },
  methods: {
    logout: function () {
      // delete this.$http.defaults.headers.common['Authorization']
      this.$store.dispatch('logout')
      .then(() => {
        this.$router.push('/login')
      })
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /*
   * Navbar
   */
  .navbar-brand {
    padding-top: .75rem;
    padding-bottom: .75rem;
    font-size: 1rem;
    background-color: rgba(0, 0, 0, .25);
    box-shadow: inset -1px 0 0 rgba(0, 0, 0, .25);
  }
  
  .navbar .navbar-toggler {
    top: .25rem;
    right: 1rem;
  }
  
  .navbar .form-control {
    padding: .75rem 1rem;
    border-width: 0;
    border-radius: 0;
  }
  
  .form-control-dark {
    color: #fff;
    background-color: rgba(255, 255, 255, .1);
    border-color: rgba(255, 255, 255, .1);
  }
  
  .form-control-dark:focus {
    border-color: transparent;
    box-shadow: 0 0 0 3px rgba(255, 255, 255, .25);
  }

</style>
